import { Component, OnInit } from "@angular/core";
import { MatDialog, MatSnackBar } from "@angular/material";
import { User } from "../shared/class/user";
import { BackendApiService } from "../shared/services/backend-api.service";
import { SessionService } from "../shared/services/session.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { environment } from "../../environments/environment.prod";

@Component({
  selector: "app-package",
  templateUrl: "./package.component.html",
  styleUrls: ["./package.component.css"],
})
export class PackageComponent implements OnInit {
  packageList: any[];
  userActivePackage: any;

  constructor(
    private snackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private sessionService: SessionService,
    private backendApiService: BackendApiService,
    public user: User,
    public dialog: MatDialog
  ) {}
  openpayment(data) {
    if (this.sessionService.isData()) {
      this.user = this.sessionService.getData();
      window.location.href =
        environment.apiUrl.baseUrl +
        "paytabPayPage?userId=" +
        this.user.id +
        "&countryISOCode=" +
        this.user.countryISOCode +
        "&deviceId=" +
        this.user.deviceId +
        "&packTypeStatus=1&deviceType=6&mediaId=" +
        data.id;
      // const dialogRef = this.dialog.open(PaymentComponent);
      //
      //     dialogRef.afterClosed().subscribe(result => {
      //       console.log(`Dialog result: ${result}`);
      //     });
      //     dialogRef.componentInstance.packageData = data;
    }
  }

  getPackageList() {
    const requestData = {
      userId: this.user.id,
      deviceTypes: "6",
    };
    this.packageList = [];
    this.backendApiService
      .postRawRequest("getPackageDetails", requestData)
      .subscribe(
        (response: any) => {
          if (response.responseCode === "SC101") {
            console.log(response);
            this.userActivePackage = response.userActivePackage;
            this.packageList = response.packageDetails;
            this.packageList.forEach(function (item) {
              item.active = response.activepackages.includes(item.id);
              if (item.packName.toUpperCase().includes("SPECIAL")) {
                item.channelTag = "Special Channels";
              } else {
                item.channelTag = "All Channels";
              }
            });
          } else if (response.responseCode === "FC101") {
            this.snackBar.open("Something went wrong", "close", {
              duration: 2000,
            });
          } else {
            this.snackBar.open("Oops!!!! . Something went wrong", "close", {
              duration: 3000,
            });
          }
        },
        (error) => {
          this.snackBar.open(
            new DOMParser()
              .parseFromString(error.error, "text/html")
              .getElementsByTagName("p")[1]
              .textContent.replace("Message", ""),
            "",
            {
              duration: 2000,
              verticalPosition: "top",
              horizontalPosition: "center",
              direction: "ltr",
            }
          );
        }
      );
  }

  ngOnInit() {
    this.getPackageList();
  }
}



// WEBPACK FOOTER //
// ./src/app/package/package.component.ts